import React from 'react'
import { shallow, mount } from 'enzyme'
import AddIpAddress from '../subComponents/AddIpAddress.jsx'

jest.mock('@fortressiq/fiq-ds', () => ({
  useNotification: () => ({
    addNotification: jest.fn(),
  }),
  useModal: () => ({
    addModal: jest.fn(),
    removeModal: jest.fn(),
  }),
  useFela: () => ({
    css: jest.fn(),
    theme: {
      'default-spacer-md': '16px',
      white: '#fff',
    },
  }),
  Button: ({ children, ...props }) => (
    <button type='button' {...props}>
      {children}
    </button>
  ),
  SwitchSection: ({ label, onSwitch, ...props }) => (
    <div {...props}>
      <label>{label}</label>
      <input type='checkbox' onChange={() => onSwitch({ SWITCH_STATE: !props.checked })} />
    </div>
  ),
  Typography: { Text: ({ textToCopy }) => <span>{textToCopy}</span> },
  theme: { 'default-spacer-md': '16px', white: '#fff' },
  Badge: ({ status }) => <span>{status}</span>,
  Popconfirm: ({ children, onConfirm }) => (
    <div>
      {children}
      <button type='button' onClick={onConfirm}>
        Confirm
      </button>
    </div>
  ),
}))

jest.mock('axios', () => ({
  get: jest.fn(() => Promise.resolve({ data: { msg: 'Success' } })),
  post: jest.fn(() => Promise.resolve({ data: { url: 'http://example.com' } })),
  put: jest.fn(() => Promise.resolve({ data: { active: false } })),
  patch: jest.fn(() => Promise.resolve({ data: true })),
}))

jest.mock('lib/Api', () => ({
  post: jest.fn(() => Promise.resolve({ data: { url: 'http://example.com' } })),
  put: jest.fn(() => Promise.resolve({ data: { active: false } })),
  patch: jest.fn(() => Promise.resolve({ data: true })),
}))

describe('Add IP Address Button Component', () => {
  it('should match snapshot', () => {
    const wrapper = shallow(<AddIpAddress whitelistStatus={true} handleReFetch={jest.fn()} />)
    expect(wrapper).toMatchSnapshot()
  })

  it('should render without crashing', () => {
    const wrapper = mount(<AddIpAddress whitelistStatus={true} handleReFetch={jest.fn()} />)
    const button = wrapper.find('.addIpAddress')
    expect(button.exists()).toBe(true)
  })
})
